import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaHandPaper, FaHandRock, FaMoneyBill, FaArrowLeft } from 'react-icons/fa';
import DelayRender from './DelayRender';
import './Games.css';
import './BlackJack.css';
import { useBlackJackGame, calculateHandValues } from './BlackJackFunctions';
import { useFireAuth } from '../FireAuthContext';

const BlackJack = () => {
  const { user } = useFireAuth();
  const userName = user ? user.name : 'User';
  const navigate = useNavigate();

  const {
    playerHand,
    dealerHand,
    dealerHandRevealed,
    gameOver,
    message,
    gameStarted,
    betAmount,
    betDenominations,
    startGame,
    playerHit,
    playerStand,
    doubleDown,
    resetGame,
    handleBet,
    clearBet,
    canDoubleDown,
    displayDealerValue,
  } = useBlackJackGame();

  return (
    <div className="page">
      <div className="page-container">
        <div className="blackjack-game">
          <div className="back-button-container">
            <FaArrowLeft className="back-button" onClick={() => navigate(-1)} />
          </div>
          <div className="game-header">
            <h2>Blackjack</h2>
          </div>
          <div className="betting-controls">
            {!gameStarted && (
              <div className="bet-buttons">
                {betDenominations.map((amount, index) => (
                  <div
                    key={index}
                    className={`chip chip-${amount}`}
                    onClick={() => handleBet(amount)}
                  >
                    <span>{amount}</span>
                  </div>
                ))}
              </div>
            )}
            {!gameStarted && betAmount > 0 && (
              <div>
                <button className="start-game-button" onClick={startGame}>
                  Place Bet 💴{betAmount}
                </button>
                <button className="clear-bet-button" onClick={clearBet}>Clear Bet</button>
              </div>
            )}
          </div>
          <div className="blackjack-hands">
            <div className="blackjack-hand">
              <h3 className="hand-title">🤵 Dealer</h3>
              <div className="cards">
                {dealerHand.map((card, index) => (
                  <div key={index} className="card dealer-card">
                    {index === 0 && !dealerHandRevealed ? '🂠' : card}
                  </div>
                ))}
              </div>
              {gameStarted && (
                <p className="hand-value">
                  Total: {displayDealerValue()}
                </p>
              )}
            </div>
            <div className="blackjack-hand">
              <h3 className="hand-title">👤 {userName}</h3>
              {user && <p className="player-info">💴 {user.money.toFixed(2)}</p>}
              <div className="cards">
                {playerHand.map((card, index) => (
                  <div key={index} className="card player-card">{card}</div>
                ))}
              </div>
              {gameStarted && (
                <p className="hand-value">
                  Total: {calculateHandValues(playerHand).softValue}
                </p>
              )}
            </div>
          </div>
          <div className="blackjack-controls">
            {gameStarted && !gameOver ? (
              <>
                <div className="button-group">
                  <button className="game-button" onClick={playerHit}>
                    <FaHandRock />&nbsp;Hit
                  </button>
                  <button className="game-button stand" onClick={playerStand}>
                    <FaHandPaper />&nbsp;Stand
                  </button>
                </div>
                {canDoubleDown && (
                  <button className="game-button double-down" onClick={doubleDown}>
                    <FaMoneyBill />&nbsp;Double Down
                  </button>
                )}
              </>
            ) : (
              gameOver && (
                <button className="game-button" onClick={resetGame}>
                  Play Again
                </button>
              )
            )}
          </div>
          {message && <div className="message">{message}</div>}
        </div>
      </div>
    </div>
  );
};

export default DelayRender(BlackJack, 200);
